import { library } from '@fortawesome/fontawesome-svg-core';

import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-duotone-svg-icons';

library.add(faSort, faSortDown, faSortUp);
